const PGAdapter = require('./../../common/pg-adapter')

const TABLE_NAME = 'avocado.data_orderline'
const COLUMNS = [
  'id',
  'order_id',
  'sku',
  'original',
  'adjusted',
  'approved',
  'received',
  'comments_facility',
  'comments_requester',
  'comments_warehouse',
  'allocation_type',
  'created_at',
  'updated_at'
]

class DataOrderLineAdapter extends PGAdapter {
  constructor (pgConnection, username, logger) {
    super(pgConnection, TABLE_NAME, username, COLUMNS, 'id', null, logger)
  }
}

module.exports = DataOrderLineAdapter
